import { createPerformanceObserver } from 'owa-analytics/lib/utils/factory';
import { trace } from 'owa-trace';

const performanceResourceTimingEntries: { [key: string]: PerformanceResourceTiming[] } = {};

/**
 * Helper function that creates a performanceObserver and waits
 * for performanceEntry associated with the given module
 * @param moduleName
 */
export function registerModuleWithPerformanceObserver(moduleName: string) {
    try {
        const resourceTimingObserver = createPerformanceObserver('resource', list => {
            list.getEntries().forEach((entry: PerformanceResourceTiming) => {
                const adjustedModuleRegExp = new RegExp(`.*[~.]+${moduleName}[~.]+.*`);
                if (adjustedModuleRegExp.test(entry.name)) {
                    if (!performanceResourceTimingEntries[moduleName]) {
                        performanceResourceTimingEntries[moduleName] = [];
                    }
                    performanceResourceTimingEntries[moduleName].push(entry);
                }
            });
        });
        resourceTimingObserver.observe({ type: 'resource', buffered: true });
    } catch (e) {
        trace.warn('Error while creating the performance observer' + e);
    }
}

/**
 * Helper function that returns the ResourceTimingEntry associated
 * with the given module.
 * Returns the time taken by largest bundle for the module, including
 * its vendor bundles.
 * @param moduleName
 */
export function getDurationForModule(moduleName: string) {
    const entriesForModule = performanceResourceTimingEntries[moduleName];
    /** Filtering out entries initiated via prefetch tags to get timings incurred when initiated from script. */
    return entriesForModule
        ? Math.max(
              ...entriesForModule
                  .filter(entry => entry.initiatorType === 'script')
                  .map(entry => entry.duration)
          )
        : 0;
}

/**
 * Helper function that returns the CacheStatus for module
 * @param moduleName
 */
export function getCacheStatusForModule(moduleName: string) {
    const entriesForModule = performanceResourceTimingEntries[moduleName];
    return entriesForModule
        ? entriesForModule.some(entry => entry.transferSize === 0 && entry.decodedBodySize >= 0)
        : false;
}
